import { InjectionToken } from '@angular/core';
export interface SmartbarTranslations {
  ariaLabel: string;
}

export const SMARTBAR_TRANSLATIONS = new InjectionToken<SmartbarTranslations>('SMARTBAR_TRANSLATIONS');
